<template>
  <v-container>
    <resource-details
      v-if="viewResource"
      :resource="viewResource"
      :focus="focusExcerpt"
      @addResourceToPage="addResourceToPage"
      @openFullModal="fullResourceId = $event"
      @back="
        view = 0;
        focus = null;
      "
    ></resource-details>
    <template v-else-if="showAll == false">
      <v-layout column class="">
        <v-card-title class="pt-0 shrink">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
            clearable
          ></v-text-field>
          <div class="flex-grow-1"></div>
          <v-switch
            class="pt-3"
            v-model="searchExcerpts"
            label="Search Excerpts"
            color="primary"
          ></v-switch>
          <!-- <v-select
              v-model="sortBy"
              hide-details
              :items="keys"
              prepend-inner-icon="sort"
              label="Sort by"
            ></v-select> -->
        </v-card-title>
        <v-data-iterator
          class=""
          style="overflow-y: auto;"
          :items="items"
          :items-per-page="10"
          :search="search"
          :page="page"
          :custom-filter="filterItems"
          :sort-by="sortBy.toLowerCase()"
          :sort-desc="false"
        >
          <template v-slot:default="props">
            <template v-for="item in props.items">
              <div class="pa-2" :key="item.id">
                <resource-card
                  variant="listItem"
                  :blockData="{ resource: item }"
                  blockType="block"
                  @click="selectResource(item)"
                ></resource-card>
              </div>
              <div class="pa-2" v-for="excerpt in filteredExcerpts[item.id]" :key="excerpt.id">
                <resource-card
                  variant="hide-image"
                  :blockData="{ resource: item, excerpts: [excerpt], highlight: search }"
                  blockType="excerpt"
                  @click="selectResource(item, excerpt.id)"
                >
                  <template v-if="userCanEdit" v-slot="props">
                    <v-tooltip right open-delay="200" transition="fade" v-if="props.hover">
                      <template v-slot:activator="{ on }">
                        <v-fade-transition>
                          <v-btn
                            outlined
                            icon
                            x-small
                            style="position: absolute; left: -8px; background: white;"
                            v-on="on"
                            @click.stop="
                              addResourceToPage({ excerptId: excerpt.id, resource: item })
                            "
                          >
                            <v-icon small>add</v-icon>
                          </v-btn>
                        </v-fade-transition>
                      </template>
                      <span>Add excerpt to notebook</span>
                    </v-tooltip>
                  </template>
                </resource-card>
              </div>
            </template>
          </template>
        </v-data-iterator>
      </v-layout>
    </template>
    <add-resource-panel v-else-if="view == 2" class="grow"></add-resource-panel>
    <v-dialog v-model="fullResourceModal" max-width="90%">
      <div style="position: relative; height: 90vh; background: white;">
        <resource-viewer v-if="fullResourceId" :resourceId="fullResourceId"></resource-viewer>
      </div>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

import AddResourcePanel from './AddResourcePanel';
import ResourceDetails from './ResourceDetails';
import ResourceCard from '@/components/Resources/ResourceCard';
import ImportResourceModal from './ImportResourceModal';
import AddResourceWidget from '@/components/Resources/AddResourceWidget';
import ResourceViewer from '@/components/ResourceViewer';
export default {
  components: {
    AddResourcePanel,
    ResourceDetails,
    ResourceCard,
    ImportResourceModal,
    AddResourceWidget,
    ResourceViewer
  },
  props: ['value', 'order', 'widget'],
  data() {
    return {
      showAll: false,
      mini: true,
      search: null,
      browseModal: false,
      importNewModal: false,
      addDropDownMenu: false,
      fullResourceId: null,
      c: console,
      searchExcerpts: false,
      focusExcerpt: null,
      itemExcerpts: {},
      iconExists: true,
      itemsPerPageArray: [4, 8, 12],
      page: 1,
      itemsPerPage: 4,
      sortBy: 'name',
      filteredExcerpts: {}
    };
  },
  computed: {
    ...mapState('resources', ['resources']),
    ...mapState('views/context', ['showResourcePanel', 'resourcePanelView', 'selectedPageId']),
    ...mapGetters('context', ['userCanEdit', 'userIsWorkspaceMember', 'context']),
    fullResourceModal: {
      get() {
        return !!this.fullResourceId;
      },
      set(v) {
        if (!v) {
          this.fullResourceId = null;
        }
      }
    },
    items() {
      return Object.values(this.resources).filter(r => !!r.usedOn[this.context.id]);
    },
    numberOfPages() {
      return Math.ceil(this.items.length / this.itemsPerPage);
    },
    view: {
      get: function() {
        return this.resourcePanelView;
      },
      set: function(v) {
        this.setResourcePanelView(v);
      }
    },
    showMini() {
      return !this.showResourcePanel;
    },
    viewResource() {
      return this.view && this.view.length > 1 ? this.resources[this.view] : false;
    }
  },
  methods: {
    ...mapMutations('views/context', ['setResourcePanelView', 'setShowResourcePanel']),
    ...mapActions('pages', ['addNoteBlock']),
    selectResource(resource, excerptId) {
      if (excerptId) {
        this.focusExcerpt = excerptId;
      } else {
        this.focusExcerpt = null;
      }
      this.view = resource.id;
    },
    filterItems(items, search) {
      this.filteredExcerpts = {};
      if (search == null) return items;
      const filtered = [];
      items.forEach(item => {
        try {
          const i = item; // make a clone
          const { title, description, provider } = i.resourceData;
          const tags = i.tags.userDefined;
          const tagString = Object.values(tags)
            .map(t => t.text)
            .toString();
          const searchableString = `${title ? title : ''} ${description ? description : ''} 
          ${provider ? provider : ''} ${tagString}`;
          let found = false;
          if (searchableString.toLowerCase().includes(search.toLowerCase())) {
            filtered.push(i);
            found = true;
          }
          if (this.searchExcerpts && search.length > 1) {
            this.filteredExcerpts[i.id] = [];
            const excerpts = Object.values(i.noteBlocks).filter(
              n => n.content.widgetType == 'textExcerpt' && !n.toDelete
            );
            excerpts.forEach(e => {
              if (e.content.widgetData.excerpt.toLowerCase().includes(search.toLowerCase())) {
                if (!found) {
                  filtered.push(i);
                  found = true;
                }
                this.filteredExcerpts[i.id].push(e);
              }
            });
          } else {
            this.fitleredExcerpts = {};
          }
        } catch (e) {
          console.log(e);
        }
      });
      return filtered;
      // search = search.toString().toLowerCase();
      // return items.filter(i => Object.keys(i).some(j => filter(i[j], search)));
    },
    addResourceToPage({ excerptId, resource }) {
      if (this.widget) {
         const resourceData = {
          pageId: this.selectedPageId,
          html: false,
          widgetInfo: {
            widgetType: 'resource',
            widgetData: {
              resourceId: resource.id,
              resourceVersion: resource.version,
              resourceNoteIds: excerptId ? [excerptId] : []
            }
          }
        }
        this.$emit('addResourceToPage', resourceData);
      } else {
        console.log(this.order);
        this.addNoteBlock({
          pageId: this.selectedPageId,
          html: false,
          order: this.order,
          widgetInfo: {
            widgetType: 'resource',
            widgetData: {
              resourceId: resource.id,
              resourceVersion: resource.version,
              resourceNoteIds: excerptId ? [excerptId] : []
            }
          }
        });
      }
      
    }
  }
};
</script>

<style></style>
